import Config from '@config';
import {
  initializeHttp,
  setupCookieUnauthorizedInterceptorFabric,
  setupCsrfInterceptor,
  setupOrganizationSessionInterceptor,
  setupRequestInterceptor,
  setupServerErrorInterceptor,
} from '@gasbi/shared/common/utils/http';

// Cookie (BFF) session: the HttpOnly cookie rides along on the same origin by
// itself (both /api and /bims); X-CSRF marks the request as first-party, a 401
// navigates the browser to the BFF's /login. setupRequestInterceptor stays for
// the organizationId header - it attaches no Bearer when no token has ever been set.
// The active organization lives in the session too (GSB-8274): a 403
// organization_unavailable re-reads it.
const instance = initializeHttp(Config.VITE_API_URL, [
  setupRequestInterceptor,
  setupOrganizationSessionInterceptor,
  setupCsrfInterceptor,
  setupCookieUnauthorizedInterceptorFabric('/api/login'),
  setupServerErrorInterceptor,
]);

export default instance;
